// PWA 第二階段「離線查閱」用的極簡 IndexedDB key-value 包裝——只給唯讀共用主檔
// （代碼檔、章碼規則清單…）存「上一次成功打 API 拿到的資料」，離線時退回顯示，
// 不是給使用者輸入的資料用（那是第三階段「檢出式離線編輯」的範圍，另外設計租約
// ＋操作佇列，見 docs/modules/budget-save.md「PWA 離線編輯與弱網機制」那段）。
//
// 用法（見 Common/data/sysCodeStore.js／Backend/ItemCode/data/chaptersStore.js）：
//   import { idbGet, idbSet } from '@/Common/offlineDb.js'
//   await idbSet('sysCode:SITE', items)   // API 成功時背景寫入，不用 await
//   const cached = await idbGet('sysCode:SITE')  // API 失敗時退回讀
//
// value 可以是任意可 structured-clone 的物件（陣列／物件都行），IndexedDB 原生
// 支援，不用先 JSON.stringify。
const DB_NAME = 'pcces-offline'
const DB_VERSION = 1
const STORE_NAME = 'kv'

let dbPromise = null
function openDb() {
  if (dbPromise) return dbPromise
  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') { reject(new Error('IndexedDB not available')); return }
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE_NAME)) {
        req.result.createObjectStore(STORE_NAME)
      }
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
  return dbPromise
}

/** 讀一筆，讀不到／IndexedDB 不可用（無痕模式、瀏覽器不支援）一律回 undefined，
 * 不丟例外——呼叫端本來就要處理「離線也沒有快取資料」這個情境，不用另外 try/catch。 */
export async function idbGet(key) {
  try {
    const db = await openDb()
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly')
      const req = tx.objectStore(STORE_NAME).get(key)
      req.onsuccess = () => resolve(req.result)
      req.onerror = () => reject(req.error)
    })
  } catch {
    return undefined
  }
}

/** 寫一筆，刻意不丟例外（容量爆滿／無痕模式存不進去）——這層快取是離線查閱的
 * 錦上添花，寫失敗不該讓「這次 API 明明成功了」的主流程跟著報錯。 */
export async function idbSet(key, value) {
  try {
    const db = await openDb()
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.objectStore(STORE_NAME).put(value, key)
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
    })
  } catch {
    // 見上方說明，刻意吞掉
  }
}
